import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { Subscription } from 'rxjs';
import { BbSelectOption } from '../shared/bb-select/bb-select.component';

@Component({
	selector: 'login-choose-publication',
	templateUrl: './login-choose-publication.component.html',
	styleUrls: ['./login-choose-publication.component.scss'],
})
export class LoginChoosePublicationComponent implements OnInit, OnDestroy {
	public availablePublications: BbSelectOption[];
	public selectedPublication: string;
	public rememberPublicationSelection: boolean;

	private subscriptions = new Subscription();

	constructor(
		private authenticationService: AuthenticationService,
	) {
		this.subscriptions.add(this.authenticationService.publicationsSubject.subscribe((publications: BbSelectOption[]) => {
			this.availablePublications = publications;
		}));
	}

	ngOnInit() { }

	ngOnDestroy() {
		if (this.subscriptions) {
			this.subscriptions.unsubscribe();
		}
	}

	loginWithPublication() {
		if (!this.selectedPublication) {
			return;
		}

		this.authenticationService.selectPublication(this.selectedPublication, this.rememberPublicationSelection);
	}
}
